import { FunctionComponent } from 'react';

import styles from './Footer.module.sass';
import ButtonLink, { ButtonSize } from '../common/ButtonLink';
import LinkGroup, { LinkGroupProps } from '../common/LinkGroup';
import { ABOUT_PAGE_SECTION, REDIRECT_URL } from '../../utils/router';

// todo Maybe extract them to the configuration file? But I don't think they will change footer's content.
const LINK_GROUPS: Record<string, LinkGroupProps> = {
    consumer: {
        title: 'Consumers',
        links: [{ text: 'Consumer Page', path: REDIRECT_URL.Consumer }],
    },
    developer: {
        title: 'Developers',
        links: [{ text: 'API Doc', path: REDIRECT_URL.Developer, newWin: true }],
    },
    business: {
        title: 'Businesses',
        links: [
            { text: 'Business Overview', path: REDIRECT_URL.BusinessOverview },
            { text: 'Income Protection', path: REDIRECT_URL.GigEconomy },
            { text: 'Product Returns', path: REDIRECT_URL.ECommerce },
            { text: 'Shipping Fee Waiver (coming soon)', path: '', disabled: true },
            { text: 'Delivery Guarantee (coming soon)', path: '', disabled: true },
        ],
    },
    about: {
        title: 'About Us',
        links: [
            { text: 'Mission', path: REDIRECT_URL.About },
            { text: 'Technology', path: `${REDIRECT_URL.About}#${ABOUT_PAGE_SECTION.Technology}` },
            { text: 'Team', path: `${REDIRECT_URL.About}#${ABOUT_PAGE_SECTION.Team}` },
            { text: 'Investors', path: `${REDIRECT_URL.About}#${ABOUT_PAGE_SECTION.Investors}` },
            { text: 'Contact', path: REDIRECT_URL.Contact },
            { text: 'Privacy Policy', path: REDIRECT_URL.Privacy, newWin: true },
            { text: 'Careers', path: REDIRECT_URL.Hiring, newWin: true },
        ],
    },
};

const Footer: FunctionComponent = () => {
    return (
        <div className={styles.expansion}>
            <footer className={styles.container}>
                <div className={styles.startCol}>
                    <div className={styles.ready}>Ready To Start?</div>
                    <ButtonLink
                        size={ButtonSize.Medium}
                        text="Explore Products"
                        href={REDIRECT_URL.Contact}
                        textColor="#11B4DD"
                    />
                </div>
                <div className={styles.links}>
                    <LinkGroup {...LINK_GROUPS.consumer} />
                    <LinkGroup {...LINK_GROUPS.developer} />
                    <LinkGroup {...LINK_GROUPS.business} />
                    <LinkGroup {...LINK_GROUPS.about} />
                </div>
                <div className={styles.copyright}>© 2021 Kover</div>
            </footer>
        </div>
    );
};

export default Footer;
